import { AvailabilitySearchUrlQuery } from '@/availability/dtos/availability-search-url-query.dto';
import { availabilityQueryToURLParamString } from '@/availability/helpers/query-url';
import {
  IAvailabilitySearchQueryInstance,
  availabilitySearchQuerySelectors,
} from '@/availability/models';
import { BookingRequest } from '@/booking';
import { OptionalProperty } from '@/common/utils/types';

import { AmendBookingRequest } from './interfaces';

export const getManageBookingUrl = (operaId = '') =>
  `/account/bookings/${operaId}/manage`;

const createAmendmentFlowUrl = (
  request: OptionalProperty<AmendBookingRequest, 'newBooking'>,
  subPath: string
) => {
  const { newBooking, oldBooking } = request;

  // If newBooking is supplied, we want to include those details in the URL.
  return newBooking
    ? `/${oldBooking.hotelSlug}/bookings/amend/${oldBooking.bookingId}/${newBooking.hotelSlug}/${newBooking.bookingId}/${subPath}`
    : `/${oldBooking.hotelSlug}/bookings/amend/${oldBooking.bookingId}/${subPath}`;
};

export const getAmendBookingConfirmChangesUrl = (
  request: AmendBookingRequest
) => createAmendmentFlowUrl(request, 'confirm-changes');

export const getAmendBookingAvailabilityUrlFromQueryInstance = ({
  query,
  oldBooking,
}: {
  query?: IAvailabilitySearchQueryInstance;
  oldBooking: BookingRequest;
}) => {
  const urlQueryString = query
    ? availabilitySearchQuerySelectors(query).asURLQueryString()
    : '';
  return createAmendmentFlowUrl(
    { oldBooking },
    `availability?${urlQueryString}`
  );
};

export const getAmendBookingAvailabilityUrl = ({
  oldBooking,
  urlQuery,
}: {
  urlQuery?: AvailabilitySearchUrlQuery;
  oldBooking: BookingRequest;
}) =>
  createAmendmentFlowUrl(
    { oldBooking },
    `availability?${
      urlQuery ? availabilityQueryToURLParamString(urlQuery) : ''
    }`
  );

export const getAmendBookingExpiredUrl = (request: AmendBookingRequest) =>
  createAmendmentFlowUrl(request, 'expired');

export const getAmendBookingAdditionalInformationUrl = (
  request: AmendBookingRequest
) => createAmendmentFlowUrl(request, 'additional-information');

export const getAmendBookingPaymentUrl = (request: AmendBookingRequest) =>
  createAmendmentFlowUrl(request, 'payment');
export const getAmendBookingPaymentPendingUrl = (
  request: AmendBookingRequest
) => createAmendmentFlowUrl(request, 'pending');

export const getAmendBookingConfirmationUrl = (request: AmendBookingRequest) =>
  createAmendmentFlowUrl(request, 'confirmation');
